import React from "react";
import "../../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Moment from 'moment';

class PoHistoryCardView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  updatePopover(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>Update</label>
        </Popover.Content>
      </Popover>
    );
  }

  showEditPODetailPanel = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: 'getPOLineItemsSuccess', data: null });
    dispatch({ type: "EditPOView", data: true });
    history.push(`/Home/POViewEdit/${shipId}/${poId}`);
    window.scrollTo(0, 0);
  };
  showEditPODetailPanelView = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: 'getPOLineItemsSuccess', data: null });
    dispatch({ type: "EditPOView", data: true });
    history.push(`/Home/POViewRead/${shipId}/${poId}/shippendingtask`);
    window.scrollTo(0, 0);
  };

  showEditPOPanel = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: 'getPOLineItemsSuccess', data: null });
    dispatch({ type: "EditPOView", data: true });
    history.push(`/Home/PurchaseOrders/${shipId}/${poId}`);
    window.scrollTo(0, 0);
  };

  showPODetailPanel = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: "EditPOView", data: false });
    history.push(`/Home/POView/${shipId}/${poId}`);
    window.scrollTo(0, 0);
  };


  render() {
    const { pageSize, totalRecords } = this.props;
    return (
      <div className="pb-4">
        <div className="row mt-3">
          <div className="col-lg-12">
            <div className="p-0">
              <div className="row">
                <div className="col-sm-12">
                  {this.renderCardPendingData()}
                </div>
              </div>
            </div>
          </div>
        </div>

        {totalRecords !== 0 ? (
          <Paginator
            first={this.state.first}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}>
          </Paginator>
        ) : (
          <div className="card" style={{ overflow: "hidden", position: "relative" }}>
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                No Tasks
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }

  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }

  renderCardPendingData = () => {
    const { arraylist, PO, confirmAll, shipPending } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div className="card" style={{ overflow: "hidden", position: "relative", marginBottom: '5px' }}>
            {/* {item.ihmPresence == "Yes" || item.ihmPresence ? (
              <div className="arrow-left-red"></div>
            ) : (
              <div className="arrow-left-green"></div>
            )} */}
            <div className="px-4 py-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-12 col- m-auto">
                    <div className="row">
                      {/* <div className="col-sm-4 col-md-3 m-auto">
                        <h6 className="resource-list-title mb-0" style={{ cursor: "pointer" }} onClick={() => this.showPODetailPanel(item.shipId, item.purchaseOrderId)}>
                          {item ? item.poNo : ""}
                        </h6>
                      </div> */}
                      <div className="col-sm-4 col-md-3 col-lg-3">
                        <span>
                          <strong>Date : </strong>
                          <span className="italicFont">{item ? Moment(new Date(Date.parse(item.poDate))).format('DD MMM YYYY') : ""}</span>
                        </span>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3">
                        <span>
                          <strong>Pulled PO's : </strong>
                          <span className="italicFont">{item ? item.pulledPo : ""}</span>
                        </span>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3">
                        <span>
                          <strong>IHM Presence PO's : </strong>
                          <span className="italicFont">{item ? item.IhmPresencePo : ""}</span>
                        </span>
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3">
                        <span>
                          <strong>Exceptions : </strong>
                          <span className="italicFont">{item ? item.exceptions : ""}</span>
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* {PO ? (
                    <div className="col-sm-2 col-md-2 col-2 col-m-auto text-right">
                      <div className="row">
                        <div className="m-auto m-1">
                          <button class="btn btn-danger btn-xs btn-conf-edit ml-1" data-confirmation="confirm" style={{ width: "102px" }} onClick={() => confirmAll(item)}>
                            <i class="glyphicon glyphicon-ok"></i> Short Close
                          </button>
                        </div>
                        <div className="m-auto m-1">
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={this.updatePopover()} >
                            <i className="fa fa-edit click" aria-hidden="true" style={{ color: " #1E3A8A", fontSize: '30px' }} onClick={() => this.showEditPOPanel(item.shipId, item.purchaseOrderId)}>
                            </i>
                          </OverlayTrigger>
                        </div>
                      </div>
                    </div>
                  ) : (shipPending ? <div className="col-sm-2 col-md-1 col-2 col-m-auto text-center">

                    <i
                      className="fa fa-eye click mr-2"
                      aria-hidden="true"
                      onClick={() => this.showEditPODetailPanelView(item.shipId, item.purchaseOrderId)}
                      style={{ color: " #1E3A8A", fontSize: '30px' }}>
                    </i>
                  </div> : <div className="col-sm-2 col-md-1 col-2 col-m-auto text-center">
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={this.updatePopover()} >
                      <i className="fa fa-edit click text-right" aria-hidden="true" style={{ color: " #1E3A8A", fontSize: '30px' }} onClick={() => this.showEditPODetailPanel(item.shipId, item.purchaseOrderId)}>
                      </i>
                    </OverlayTrigger>
                  </div>)} */}
                </div>
              </div>
            </div>
          </div>
        );
      }) : null;
  };

  ShowSidePanel = (id) => {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/EquipmentEdit/${id}/single`);
  };

  editEquipmentDetails = (id, type) => {
    this.props.dispatch({ type: "EditEquipmentDetails", data: true });
    this.props.history.push(`/Home/ShipDetails/EquipmentEdit/${id}/${type}`);
  };
}

function mapStateToProps(state) {
  return {
    PurchaseOrders: state.MMPLDashboardReducer.PurchaseOrders,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PoHistoryCardView)
);
